/**
 * Общий модуль для календарей
 */
itsoftApp.createModule('flatPickerLibrary', function () {
    // Локальные переменные
    const queue = [];
    let module = this;
    let libraryLoaded = false;
    let loadingStarted = false;
    window.flatPicker = {};

    /**
     * Вызов всех функций, которые были добавлены
     * в массив queue в процессе загрузки библиотеки
     * (до этого момента их вызов привёл бы к ошибке).
     */
    var initQueue = function () {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log('[module slidersLibrary] initQueue function fired, queue.length: ' + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };

    /**
     * Загрузить библиотеку и выполнить
     * отложенные функции из массива queue.
     */
    const loadAndInit = function () {
        const f = function () {
            libraryLoaded = true;
            initQueue();
        };

        // Случай, если библиотека вдруг уже загружена
        // (например, если она принудительна вставлена в html через <script>)
        itsoftApp.loadStyle('/assets/scripts/libraries/flatPicker/flatpickr-v-4.6.8.min.css');
        itsoftApp.loadScript('/assets/scripts/libraries/flatPicker/flatpickr-v-4.6.8.min.js', function () {
            DEBUG && console.log('[module slidersLibrary] library loaded, ready to init queue');
            f();
        });
    };

    /**
     * Добавление переданной функции в очередь на выполнение,
     * либо немедленное исполнение функции, если библиотека уже загружена.
     *
     * @param {function} func
     */
    const addEvent = function (func) {
        if (typeof func !== 'function') {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log('%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)', 'font-style: italic; color: #999');
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log('[module slidersLibrary] function added, count of functions to init now: ' + queue.length);

            // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };

    /**
     * Функция инициализации range слайдера.
     * @param flatpicker - HTMLElement
     * @param params - объект с параметрами
     */
    const setFlatPicker = function (flatpicker, params = {}) {
        const initUiSlider = function () {
            let flatpickerConfig = {};

            if (params.config) {
                flatpickerConfig = params.config;
            }

            flatpickr(flatpicker, flatpickerConfig);
        };

        addEvent(initUiSlider);
    };

    module.addEvent = addEvent;
    module.callback = setFlatPicker;
});
